import { default as React } from 'react';
import { makeStyles } from '@mui/styles';
import skyStageIcon from './../../static/skyStageIcon.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 40,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img src={skyStageIcon} alt="SkyStage Logo" className={classes.img} />;
};

export default LogoIcon;
